import { EventoTipo } from "../../../response/ventas/OportunidadResponse";

/**
 * Evento manual sobre una oportunidad (POST /ventas/pipeline/{id}/evento).
 * El usuarioId lo toma el backend del token. Nunca enviar tipo "stage_change".
 */
export class EventoPayload {
  tipo: Exclude<EventoTipo, "stage_change"> = "note";
  metadata?: Record<string, unknown>;  // según tipo: note → { texto: string }; resto libre
}
